import { useState, useCallback, useRef } from 'react';

import useInputMetadata from 'apps/web_forms/hooks/useInputMetadata';
import { useDispatch } from 'react-redux';

const useChangeValue = (element, onChangeValue, formContext) => {
  const { getValues } = formContext;
  const { identifier } = element;
  const currentValue = useRef('');

  const { updateInputMetadata } = useInputMetadata({ element });
  const dispatch = useDispatch();

  const changeValue = useCallback(
    (value, isDirty = false) => {
      if (!value || value !== currentValue.current) {
        const virtualizedElementValue = getValues(identifier);
        const fieldValue = value ?? virtualizedElementValue;
        onChangeValue(identifier, fieldValue, isDirty);
        currentValue.current = fieldValue ?? '';

        updateInputMetadata(() => {
          // Trigger changes again after metadata updating
          // onChangeValue(identifier, fieldValue);
        });
      }
    },
    [identifier, onChangeValue]
  );

  return { changeValue, currentValue: currentValue.current };
};

export default useChangeValue;




